import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';

export interface TeslaState {
    rankList: ListWrap<Tesla.RankItem> & ListRequesting;
    info: Tesla.Info | null;
    inviteCard: string | null;
    couponList: Tesla.CouponItem[];
}

const m: Module<TeslaState, RootState> = {
    namespaced: true,
    state: () => ({
        rankList: {
            list: [],
            loaded: false,
            requesting: false,
        },
        info: null,
        inviteCard: null,
        couponList: [],
    }),
    mutations: {
        concatList(state, list) {
            state.rankList.list.push(...list);
        },
        setListLoaded(state, loaded) {
            state.rankList.loaded = loaded;
        },
        setListReq(state, req) {
            state.rankList.requesting = req;
        },
        setInfo(state, info: Tesla.Info) {
            state.info = info;
        },
        setInviteCard(state, card) {
            state.inviteCard = card;
        },
        setCouponList(state, list) {
            state.couponList = list;
        },
    },
    actions: {
        /**
         * 获取排行榜
         * @param {} offset
         * @param {} count
         * @param {} forceUpdate
         */
        async getRankList({ state, commit }, { offset,
        count, forceUpdate = false }) {
            const wrap = state.rankList;
            if (wrap.requesting || (wrap.loaded && !forceUpdate)) {
                return;
            }
            if (forceUpdate) {
                wrap.loaded = false;
                wrap.list = [];
            }
            const list = wrap.list;
            const end = offset + count;
            if (end <= list.length) {
                return;
            }
            if (offset < list.length) {
                offset = list.length;
                count = end - offset;
            }
            commit('setListReq', true);
            const response = await Vue.axios.get('/api/v1/temp_activity/period_14_tesla/rank', {
                params: {
                    offset,
                    count,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('concatList', rdata.data);
                if (rdata.data.length < count) {
                    commit('setListLoaded', true);
                }
            }
            commit('setListReq', false);
            return rdata;
        },
        /**
         * 获取活动信息
         * @param {} forceUpdate
         */
        async getActivityInfo({ state, commit }, forceUpdate = false) {
            if (state.info && !forceUpdate) {
                return;
            }
            const response = await Vue.axios.get('/api/v1/temp_activity/period_14_tesla/info');
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setInfo', rdata.data);
            }
            return rdata;
        },
        /**
         * 获取邀请卡
         * @param {} forceUpdate
         */
        async getInviteCard({ state, commit }, forceUpdate = false) {
            if (state.inviteCard && !forceUpdate) {
                return {
                    status: 0,
                };
            }
            const response = await Vue.axios.get('/api/v1/temp_activity/period_14_tesla/invite_card');
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setInviteCard', rdata.data.url);
            }
            return rdata;
        },
        /**
         * 获取奖券列表
         * @param {} forceUpdate
         */
        async getCouponList({ state, commit }, forceUpdate = false) {
            if (state.couponList && !forceUpdate) {
                return;
            }
            const response = await Vue.axios.get('/api/v1/temp_activity/period_14_tesla/coupon_list');
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setCouponList', rdata.data);
            }
            return rdata;
        },
    },
};

export default m;
